import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const AssignToOtherIcon = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 18 18" {...props}>
        <g id="AssignToOtherIcon" data-name="AssignToOtherIcon">
            <g id="Group_Icon" data-name="Group Icon">
                <polygon
                    id="BoundingBox"
                    points="0 0 18 0 18 18 0 18"
                    fill="none"
                />
                <path
                    id="User"
                    fill="currentColor"
                    d="M6.75,9 C8.4075,9 9.75,7.6575 9.75,6 C9.75,4.3425 8.4075,3 6.75,3 C5.0925,3 3.75,4.3425 3.75,6 C3.75,7.6575 5.0925,9 6.75,9 Z M6.75,10.5 C4.7475,10.5 0.75,11.505 0.75,13.5 L0.75,15 L12.75,15 L12.75,13.5 C12.75,11.505 8.7525,10.5 6.75,10.5 Z"
                />
                <polygon
                    id="Arrow"
                    fill="currentColor"
                    transform="translate(14.25, 8.25) rotate(-180) translate(-14.25, -8.25)"
                    points="17.25 7.875 12.68625 7.875 14.7825 5.77875 14.25 5.25 11.25 8.25 14.25 11.25 14.77875 10.72125 12.68625 8.625 17.25 8.625"
                />
            </g>
        </g>
    </SvgIcon>
);

export default AssignToOtherIcon;
